module.exports = __webpack_public_path__ + "img/icon_in_carica.96c0f738.png";